import type { Resource } from '../../';
export const country_countries_IT: Resource = {"default":"Italy"};
